import axios from 'axios';
import { ENDPOINTS } from '../constants';
import { IChallenge } from '../types/IChallenge';

export interface IChallengesRequestsParams {
    pageNumber: number;
    pageSize: number;
}

interface IGetChallengesResponse {
    total: number;
    entities: IChallenge[];
}

export const getChallenges = async (params: IChallengesRequestsParams): Promise<IGetChallengesResponse> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.getChallenges}`, { params });
    return res.data;
};
